import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerWorkOrderChangeDraftInfoGql } from '../../WorkOrderChangeQueries';

const requestId = 'uerWorkOrderChangeDraftInfo';

export const useUerWorkOrderChangeDraftInfo = () => {
    const dispatch = useDispatch();
    const [uerWorkOrderChangeDraftInfoReset] = useResetStoreData({ requestId });

    const [uerWorkOrderChangeDraftInfoData, uerWorkOrderChangeDraftInfoStatus, , uerWorkOrderChangeDraftInfoRequest] =
        useRequest({
            requestId,
            query: uerWorkOrderChangeDraftInfoGql,
            withEffect: false,
        });

    const uerWorkOrderChangeDraftInfoRefresh = useCallback(
        (workOrderChangeId: number) => {
            dispatch(uerWorkOrderChangeDraftInfoRequest({ workOrderChangeId }));
        },
        [dispatch, uerWorkOrderChangeDraftInfoRequest],
    );

    useEffect(() => {
        uerWorkOrderChangeDraftInfoReset(undefined);
    }, [uerWorkOrderChangeDraftInfoReset]);

    return {
        uerWorkOrderChangeDraftInfoData,
        uerWorkOrderChangeDraftInfoStatus,
        uerWorkOrderChangeDraftInfoRefresh,
    };
};
